import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SkeletonCard() {
    return (_jsxs("div", { "aria-hidden": "true", style: {
            background: "var(--panel)",
            border: "1px solid var(--border)",
            borderLeft: "6px solid var(--border)",
            borderRadius: "var(--radius)",
            padding: "20px 24px",
            overflow: "hidden",
        }, children: [_jsx("style", { children: `
        @keyframes aeos-shimmer {
          0%   { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .aeos-shimmer {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--panel-soft, #f8fbff) 50%,
            var(--border) 75%
          );
          background-size: 800px 100%;
          animation: aeos-shimmer 1.4s infinite linear;
          border-radius: 6px;
        }
      ` }), _jsx("div", { className: "aeos-shimmer", style: { height: 12, width: "40%", marginBottom: 10 } }), _jsx("div", { className: "aeos-shimmer", style: { height: 18, width: "70%", marginBottom: 16 } }), _jsxs("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }, children: [_jsx("div", { className: "aeos-shimmer", style: { height: 32 } }), _jsx("div", { className: "aeos-shimmer", style: { height: 32 } })] })] }));
}
//# sourceMappingURL=SkeletonCard.js.map